<template lang="pug">
p.suus__html-text(
  ref="rootRef",
  :class="`mb-0 ${customClass}`",
  :style="htmlStyles",
  v-html="html"
)
</template>

<script lang="ts">
import Vue, { onMounted, PropType, Ref, ref, toRef, watch } from "vue"

import THEME from "../../constants/theme"
import TextHTMLAttachmentListItem from "components/TextHTMLAttachmentListItem.vue"
const { text } = THEME.typography

export default Vue.extend({
  name: "TextHTML",
  components: {
    TextHTMLAttachmentListItem,
  },
  props: {
    html: String,
    customClass: { type: String, default: "" },
    renderComponents: {
      type: Function as PropType<(root: Ref<HTMLElement>) => Promise<void>>,
      default: (_) => Promise.resolve(),
    },
  },
  computed: {
    htmlStyles(): { fontFamily: string; fontSize: string; lineHeight: string } {
      let styles = {
        ...text,
        color: this.$vuetify.theme.themes.light.textColor,
      }

      return styles
    },
  },
  setup(props) {
    const rootRef = ref<HTMLElement>()
    const html = toRef(props, "html")

    onMounted(() => {
      watch(
        html,
        async () => {
          if (props.renderComponents) {
            await props.renderComponents(rootRef)
          }
        },
        { immediate: true }
      )
    })

    return {
      rootRef,
    }
  },
})
</script>

<style lang="sass">
$primary-color: rgba(50, 131, 247, 1)
.suus__editor__wysiwyg__image
  cursor: pointer
.suus__html-text
  > * + *
    margin-top: 0.75em
    ul,
    ol
      padding: 0 1rem

    h1,
    h2,
    h3,
    h4,
    h5,
    h6
      line-height: 1.1

    pre
      background: #0D0D0D
      color: #FFF
      padding: 0.75rem 1rem
      border-radius: 0.5rem

    blockquote
      padding-left: 1rem
      border-left: 2px solid rgba($primary-color, 0.1)
    a
      color: $primary-color
    mark
      background-color: #ffe066

    .mention
      border: 1px solid rgba(34, 36, 38, 0.15) !important
      border-radius: 0.14285714rem !important
      transition: background 0.1s ease !important
      padding: 0.283rem 0.433rem !important
      font-size: 0.875em !important
      background: #307ef7 !important
      color: white !important
      font-weight: 500 !important
      display: inline-block !important
      white-space: nowrap !important
      line-height: initial !important
      margin: 0 0.25em !important
      &:before
        font-family: "Icons"
        font-size: 1.2em
        vertical-align: sub
        padding-right: 0.5rem
        font-weight: 600
      .group-mention
        &:before
          content: "\eef8"
      .member-mention
        &:before
          content: "\f075"
</style>
